import { createSlice } from '@reduxjs/toolkit';
import { loginUser } from './loginAction';

export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    loading: false,
    token: null,
    data: {},
    message: '',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // login slice
    builder.addCase(loginUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(loginUser.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload.user;
      state.token = payload.token;
      state.message = payload.message;
      state.error = null;
    });
    builder.addCase(loginUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'An error occurred';
    });
  },
});
